module.exports = __webpack_public_path__ + "img/fig34.885d08cc.jpg";